const e = "omnichannelChatWidget/openedAction", t = "omnichannelChatWidget/closedAction", n = "omnichannelChatWidget/messageSentAction", o = () => ({
  event: "chatbot",
  event_action: "telemetry_click_opened",
  non_interaction: !1
}), c = () => ({
  event: "chatbot",
  event_action: "telemetry_click_closed",
  non_interaction: !1
}), a = () => ({
  event: "chatbot",
  event_action: "telemetry_message_sent",
  non_interaction: !1
}), s = {
  [e]: o,
  [t]: c,
  [n]: a
}, i = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CLOSED_ACTION: t,
  MESSAGE_SENT_ACTION: n,
  OPENED_ACTION: e,
  closedEvent: c,
  eventsMap: s,
  messageSentEvent: a,
  openedEvent: o
}, Symbol.toStringTag, { value: "Module" }));
export {
  t as C,
  n as M,
  e as O,
  c,
  a as m,
  o,
  i as t
};
//# sourceMappingURL=index-D6nxKimq.js.map
